import { makeVar } from "@apollo/client";

export const goBackVar = makeVar(null);

export const ITEMS_PER_PAGE = 50;
